export default "__VITE_ASSET__7c531039__"